import { render, staticRenderFns } from "./information.view.vue?vue&type=template&id=b9426e64&"
import script from "./information.view.vue?vue&type=script&lang=ts&"
export * from "./information.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports